import styled from 'styled-components';
import Typography from '../../../../theme/typography';

const StyledCategory = styled.div`
  h4 {
    ${Typography.Subtitle1}
  }

  p {
    ${Typography.Body3}
  }
`;
export default StyledCategory;
